module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"personal":"Personal","financial":"Financial","vehicle":"Vehicle","banking":"Banking","appraisal":"Appraisal"}}')
  delete Component.options._Ctor
}
